export default {
  path: "/",
  name: "System",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "RBAC",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
        },
        {
          path: "/userView",
          name: "Users",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/system/RBAC/users/userView.vue"),
            },
            {
              path: "createUser",
              name: "Create User",
              component: () =>
                import("@/views/system/RBAC/users/createUser.vue"),
            },
            {
              path: "editUserData/:id",
              name: "Edit User Data",
              component: () =>
                import("@/views/system/RBAC/users/EditUserData.vue"),
            },
            {
              path: "viewUser/:id",
              name: "View User",
              component: () => import("@/views/system/RBAC/users/viewUser.vue"),
            },
          ],
        },
        {
          path: "/manageRoles",
          name: "Roles",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/RBAC/ManageRoles/RolesList"),
            },
            {
              path: "/createrole",
              name: "Create Role",
              component: () =>
                import("@/views/system/RBAC/ManageRoles/CreateRoles"),
            },
            // {
            //   path: "/managepermissions/:id",
            //   name: "Manage Permissions",
            //   component: () =>
            //     import("@/views/system/RBAC/ManageRoles/RolesPermission"),
            // },
            {
              path: "/managepermissions/:id",
              name: "Manage Permissions",
              component: () =>
                import("@/views/system/RBAC/ManageRoles/ManageRolesPermission"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Currency Master",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
        },
        {
          path: "/currencyconfig",
          name: "Currency Non-Currency",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/CurrencyMaster/currencyconfig.vue"),
            },
            {
              path: "/createCurrency",
              name: "Create Currency",
              component: () =>
                import("@/views/system/CurrencyMaster/createCurrency.vue"),
            },
            {
              path: "/editCurrency/:id",
              name: "Edit Currency",
              component: () =>
                import("@/views/system/CurrencyMaster/editCurrency.vue"),
            },
            {
              path: "/viewCurrency/:id",
              name: "View Currency",
              component: () =>
                import("@/views/system/CurrencyMaster/viewCurrency.vue"),
            },
          ],
        },
        {
          path: "/currencyExchangeList",
          name: "Currency Exchange",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/CurrencyMaster/currencyExchangeRates/currencyExchangeList.vue"
                ),
            },
            {
              path: "/viewCurrencyExchange/:id",
              name: "View Currency Exchange",
              component: () =>
                import(
                  "@/views/system/CurrencyMaster/currencyExchangeRates/viewCurrencyExchange.vue"
                ),
            },
            {
              path: "/createCurrencyExchange",
              name: "Create Currency Exchange",
              component: () =>
                import(
                  "@/views/system/CurrencyMaster/currencyExchangeRates/createCurrencyExchange.vue"
                ),
            },
            {
              path: "/editCurrencyExchange/:id",
              name: "Edit Currency Exchange",
              component: () =>
                import(
                  "@/views/system/CurrencyMaster/currencyExchangeRates/editCurrencyExchange.vue"
                ),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Configurations",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
        },
        {
          path: "/globalConfig",
          name: "Global Configuration",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/globalConfig"
                ),
            },
          ],
        },
        {
          path: "/paymentConfig",
          name: "Payment Gateway Configuration",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/paymentConfig"
                ),
            },
          ],
        },
        {
          path: "/systemHooks",
          name: "Hooks",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/Config/ConfigurationsSystem/hooks"),
            },
            {
              path: "/createEventAction",
              name: "Create Event Action",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/createEventAction.vue"
                ),
            },
            {
              path: "/editEventAction/:id",
              name: "Edit Event Action",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/editEventAction.vue"
                ),
            },
            {
              path: "/viewEventAction/:id",
              name: "View Event Action",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/viewEventAction.vue"
                ),
            },
          ],
        },
        {
          path: "/systemEnum",
          name: "ENUM",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/Config/ConfigurationsSystem/enum"),
            },
            {
              path: "viewEnum/:name",
              name: "View Enum",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/viewEnum.vue"
                ),
            },
            {
              path: "/createEnum",
              name: "Create Enum",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/createEnum.vue"
                ),
            },
            {
              path: "editEnum/:name",
              name: "Edit Enum",
              component: () =>
                import(
                  "@/views/system/Config/ConfigurationsSystem/editEnum.vue"
                ),
            },
          ],
        },
        {
          path: "/provisioningDevice",
          name: "Provisioning Device",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/provisioningDevice"
                ),
            },
            {
              path: "/createDevice",
              name: "Create Device",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/createDevice.vue"
                ),
            },
            {
              path: "/editCreateDevice/:id",
              name: "Edit Create Device",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/editCreateDevice.vue"
                ),
            },
          ],
        },
        {
          path: "/provisionCommand",
          name: "Provision Command",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/provisionCommand"
                ),
            },
            {
              path: "/createCommand",
              name: "Create Command",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/createCommand.vue"
                ),
            },
            {
              path: "/viewProvisioningMapping/:id",
              name: "View Provisioning Mapping",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/viewProvisioningMapping.vue"
                ),
            },
            {
              path: "/editCreateCommand/:id",
              name: "Edit Create Command",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/editCreateCommand.vue"
                ),
            },
          ],
        },
        {
          path: "/provisioningAction",
          name: "Provisioning Action",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/provisioningActions"
                ),
            },
          ],
        },
        {
          path: "/networkSystem",
          name: "Network System",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/networkSystem"
                ),
            },
            {
              path: "/createSystem",
              name: "Create System",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/createSystem.vue"
                ),
            },
            {
              path: "/editCreateSystem/:id",
              name: "Edit Create System",
              component: () =>
                import(
                  "@/views/system/Config/provisioningConfiguration/editCreateSystem.vue"
                ),
            },
          ],
        },
        {
          path: "/manageCodesList",
          name: "Manage Codes",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/Config/manageCodes/manageCodesList.vue"),
            },
            {
              path: "/createManageCodes",
              name: "Create Manage Codes",
              component: () =>
                import(
                  "@/views/system/Config/manageCodes/createManageCodes.vue"
                ),
            },
            {
              path: "/viewManageCodes/:id",
              name: "View Manage Codes",
              component: () =>
                import("@/views/system/Config/manageCodes/viewManageCodes.vue"),
            },
            {
              path: "/editManageCodes/:id",
              name: "Edit Manage Codes",
              component: () =>
                import("@/views/system/Config/manageCodes/editManageCodes.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/makerchecker",
      name: "Maker Checker",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import(
              "@/views/system/MakerChecker/ConfigureMakerChecker/Index.vue"
            ),
        },
        {
          path: "approval",
          name: "Approval",
          component: () =>
            import(
              "@/views/system/MakerChecker/MakerCheckerApproval/Index.vue"
            ),
        },
        {
          path: "view_approval/:id",
          name: "View Approval",
          component: () =>
            import(
              "@/views/system/MakerChecker/MakerCheckerApproval/view_approval.vue"
            ),
        },
      ],
    },
    {
      path: "/configurationList",
      name: "Configuration List",
      component: () =>
        import(
          "@/views/system/Config/ConfigurationsSystem/configurationList.vue"
        ),
    },
    {
      path: "/config",
      name: "Config",
      component: () => import("@/views/system/Config/Index.vue"),
    },
    {
      path: "/reportsList",
      name: "Manage Reports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import("@/views/system/manageReports/reportsList.vue"),
        },
        {
          path: "/editManageReports/:id",
          name: "Edit Manage Reports",
          component: () =>
            import("@/views/system/manageReports/editManageReports.vue"),
        },
        {
          path: "/createReport",
          name: "Create Report",
          component: () =>
            import("@/views/system/manageReports/createReport.vue"),
        },
        {
          path: "/viewReports/:id",
          name: "View Reports",
          component: () =>
            import("@/views/system/manageReports/viewReports.vue"),
        },
      ],
    },
    {
      path: "/holiday-management",
      name: "Holiday Management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/system/holiday_management/index.vue"),
        },
        {
          path: "edit-holiday/:id",
          name: "Edit Holiday",
          component: () => import("@/views/system/holiday_management/edit.vue"),
        },
        {
          path: "view-holiday/:id",
          name: "View Holiday",
          component: () => import("@/views/system/holiday_management/view.vue"),
        },
        {
          path: "create-holiday",
          name: "Create Holiday",
          component: () => import("@/views/system/holiday_management/create.vue"),
        },
      ]
    },
    {
      path: "/question-answer-set",
      name: "Q & A Set",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import("@/views/system/question_answer_set/index.vue"),
        },
        {
          path: "edit-question-set/:category/:subCategory",
          name: "Edit Question Set",
          component: () =>
            import("@/views/system/question_answer_set/edit.vue"),
        },
        {
          path: "create-question-set",
          name: "Create Question Set",
          component: () =>
            import("@/views/system/question_answer_set/create.vue"),
        },
      ],
    },
    {
      path: "/shift-management",
      name: "Shift Management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/system/shift_management/index.vue"),
        },
        {
          path: "edit-shift/:name",
          name: "Edit Shift",
          component: () => import("@/views/system/shift_management/edit.vue"),
        },
        {
          path: "view-shift/:name/:id",
          name: "View Shift",
          component: () => import("@/views/system/shift_management/view.vue"),
        },
        {
          path: "create-shift",
          name: "Create Shift",
          component: () => import("@/views/system/shift_management/create.vue"),
        },
      ],
    },
    {
      path: "/user-shift-mapping",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          name: "User Working Shift",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/user_shift_mapping/index.vue"),
            },
            {
              path: "create_user_shift_mapping",
              name: "Create User Working Shift",
              component: () =>
                import("@/views/system/user_shift_mapping/create.vue"),
            },

            {
              path: "edit_user_shift_mapping/:teamId/:shiftId",
              name: "Edit User Working Shift",
              component: () =>
                import("@/views/system/user_shift_mapping/edit.vue"),
            },
            {
              path: "view_user_shift_mapping/:id",
              name: "View User Working Shift",
              component: () =>
                import("@/views/system/user_shift_mapping/view.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/calendar",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "/calendar",
          name: "Calendar",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/system/calendar/index.vue"),
            },
          ],
        },
      ],
    },

    //Provisioning Configuration
    {
      path: "/provisioningConfigList",
      name: "Provisioning Config List",
      component: () =>
        import(
          "@/views/system/Config/provisioningConfiguration/provisioningConfigList.vue"
        ),
    },
    {
      path: "message-template",
      name: "Message Template",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import("@/views/system/MessageTemplate/listMessageTemplate.vue"),
        },
        {
          path: "viewMessageTemplate/:id",
          name: "View Message Template",
          component: () =>
            import("@/views/system/MessageTemplate/viewMessageTemplate.vue"),
        },
        {
          path: "createMessageTemplate",
          name: "Create Message Template",
          component: () =>
            import("@/views/system/MessageTemplate/createMessageTemplate.vue"),
        },
        {
          path: "editMessageTemplate/:id",
          name: "Edit Message Template",
          component: () =>
            import("@/views/system/MessageTemplate/editMessageTemplate.vue"),
        },
      ],
    },
  ],
};
